// extracted by mini-css-extract-plugin
export default {"ava":"user_ava__x-QIP","deactivated":"user_deactivated__LUIof"};